import { NOOP } from 'constants/actions';
import type { MouseEventHandler } from 'react';
import { useTranslations } from 'utils/translations/useTranslations';
import { ReactComponent as BackIcon } from './assets/ico-arrow-back.svg';

import './BackButton.scss';
import classNames from 'classnames';

interface BackButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

export const BackButton = ({
  onClick = NOOP,
  className,
  ...rest
}: BackButtonProps) => {
  const i18n = useTranslations();

  return (
    <button
      {...rest}
      className={classNames('Back-button', className)}
      onClick={onClick}
    >
      <BackIcon />
      {i18n.t('checkout.navigation.back')}
    </button>
  );
};
